import Api from "../../utils/axios";

export const DocApi = {
  getAllDocuments: (payload, searchQuery) =>
    Api.post(`master/get-all-document-master?search=${searchQuery}`, payload),
  getSingleDocument: (payload, _id) =>
    Api.get(`master/get-document-master/${_id}`, payload),
  getDocument: (_id) => Api.get(`master/get-all-document/${_id}`),
  getAllUserRole: (payload, search = "") =>
    Api.get(`admin/get-all-user-roles`, payload),
  createDocument: (payload) =>
    Api.post(`master/create-document-master`, payload),
  updateDocument: (payload, _id) =>
    Api.put(`master/update-document-master/${_id}`, payload),
  deleteDocument: (_id) => Api.delete(`master/delete-document-master/${_id}`),
};
